export default "__VITE_ASSET__CRij0XnE__"